import { useState } from 'react';
import './Pricing.css';

const PLAN = {
  name: 'Aiva Chat Suite',
  desc: 'ChatBot for HR, IT, Finance, Marketing & Sales',
  priceINR: '₹450.00',
  priceUSD: '$5.0',
  seats: 200,
};

export default function Pricing() {
  const [currency, setCurrency] = useState('INR');

  return (
    <section id="pricing" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Pricing</span>
        <h2 className="sec-title">Simple pricing for Aiva Chat Suite.</h2>
        <p className="sec-sub">
          One plan covering HR, IT, Finance, Marketing and Sales — scale seats up
          as your team grows.
        </p>

        <div className="pricing__wrap">
          <div className="price-card">
            <div className="price-card__top">
              <div>
                <div className="price-card__name">{PLAN.name}</div>
                <p className="price-card__desc">{PLAN.desc}</p>
              </div>
              <div className="price-card__toggle" role="tablist" aria-label="Currency">
                <button
                  type="button"
                  className={currency === 'INR' ? 'active' : ''}
                  onClick={() => setCurrency('INR')}
                  role="tab"
                  aria-selected={currency === 'INR'}
                >
                  INR
                </button>
                <button
                  type="button"
                  className={currency === 'USD' ? 'active' : ''}
                  onClick={() => setCurrency('USD')}
                  role="tab"
                  aria-selected={currency === 'USD'}
                >
                  USD
                </button>
              </div>
            </div>

            <div className="price-card__amount">
              {currency === 'INR' ? PLAN.priceINR : PLAN.priceUSD}
            </div>
            <p className="price-card__note">Contact us for full billing terms.</p>

            <ul className="price-card__features">
              <li>Up to {PLAN.seats} users included</li>
              <li>HR, IT, Finance, Marketing &amp; Sales bots</li>
              <li>Scales with your team — talk to us for higher tiers</li>
            </ul>

            <a href="#contact" className="btn-primary price-card__cta">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
